<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card"> 
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                                                <div class="ml-2">
                                                  <h3 class="main-content-label mb-1"><b>
                                                    {{'header.tehasil.title' | translate }}
                                                  </b></h3>
                                                  <p class="text-muted card-sub-title mb-0">
                                                  {{'header.tehasil.table.tehasilList' | translate }}
                                                  </p>
                                                </div>
                                              </div> 
                                        </div>
                                        <div class="col-md-3" [formGroup]="TehasilSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.tehasil.table.Search' | translate }}
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-1 prpl">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                        {{'header.tehasil.table.addnewrecord' | translate }}
                                                </span>
                                            </button>
                                        </div>
                                        <div class="col-md-1 prpl1">
                                            <button type="button" class="btn sz btn-primary btn-icon-text floatright mt-1 fr" (click)="Print()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                    {{'header.tehasil.table.Print' | translate }}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable" class="table  table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th  class="f600" width="15%">
                                                        {{'header.tehasil.table.districtName' | translate }}
                                                    </th>
                                                    <th  class="f600" width="15%">
                                                        {{'header.tehasil.table.tehasilCode' | translate }}
                                                    </th>
                                                    <th  class="f600" >
                                                        {{'header.tehasil.table.tehasilName' | translate }}
                                                    </th>
                                                    <th  class="f600 text-center" width="10%">
                                                        {{'header.tehasil.table.Action' | translate }} </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let tehasil of tehasilList;">
                                                
                                                    <td> {{tehasil.DsName}} </td>
                                                    <td>{{tehasil.TsCode}} </td>
                                                    <td>{{tehasil.TsName}} </td>
                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                        (click)="editData(tehasil)" >
                                                         <i class="fa fa-edit "></i> 
                                                        </a> 
                                                        <a class=" ml-2 floating"
                                                        title="Delete"  (click)="deleteData(tehasil)"> 
                                                        <i class="fas fa-trash"></i> 
                                                        </a> 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    </body>
    
    